export default __webpack_public_path__ + "2d42e52e1a2179b438ae5f15eb16a036.png";